import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, {useState} from "react";

const headers = [
  {
    key: "loyalty_name",
    name: "Loyalty Name",
  },
  {
    key: "loyalty_type",
    name: "Loyalty Type",
  },
  {
    key: "amount",
    name: "Amount",
  },
  {
    key: "point",
    name: "Point",
  },
  {
    key: "start_date",
    name: "Start Date",
  },
  {
    key: "end_date",
    name: "End Date",
  },
  {
    key: "status",
    name: "Status",
  },
];

const LoyaltyList = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [searchValue, setSearchValue] = useState("");

  const handleSearch = (value) => {
    //console.log("searching value: ", value);
    const trimmed = value.trim();
    if(trimmed.length > 0){
      setSearchValue(trimmed);
      setQuery({
        search: trimmed,
      });
    }else{
        setQuery({
      
    });
    }
  };

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/loyalty",
    defaultQuery: "status=ACTIVE",
  });

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Loyalty List"
      data={data}
      headers={headers}
      idKey="loyalty_id"
      endPoint="/loyalty"
      setCurrentPage={setCurrentPage}
      removeDetails={true}
      hasSearch
      hasCreate
      hasActions
      module="Loyalty"
      subModule="Loyalty List"
      totalCount={data.totalCount}
      createPath={`/loyalty/list/create`}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      disabledSerial
      reload={reload}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
      setQuery={setQuery}
    />
  );
};

export default LoyaltyList;
